import type { HotkeyKey, HotkeyModifiers } from './hotkeys.types'
import { isMac } from './isMac'

const KEY_DISPLAY_MAP: Partial<Record<HotkeyKey, string>> = {
  ArrowLeft: '←',
  ArrowRight: '→',
  ArrowUp: '↑',
  ArrowDown: '↓',
  Escape: 'Esc',
  Delete: 'Del',
  Backspace: 'Backspace',
  Enter: 'Enter'
}

export function formatHotkeyLabel(binding: { key: HotkeyKey; modifiers?: HotkeyModifiers }): string {
  const parts: string[] = []

  if (binding.modifiers?.mod) parts.push(isMac() ? 'Cmd' : 'Ctrl')
  if (binding.modifiers?.ctrl) parts.push('Ctrl')
  if (binding.modifiers?.shift) parts.push('Shift')
  if (binding.modifiers?.alt) parts.push('Alt')

  const keyDisplay = KEY_DISPLAY_MAP[binding.key] ?? binding.key
  const formattedKey = keyDisplay.length === 1 && /[a-z]/.test(keyDisplay) ? keyDisplay.toUpperCase() : keyDisplay

  parts.push(formattedKey)

  return parts.join('+')
}
